export const InvoiceStatusEnum = {
  DRAFT: "DRAFT",
  OPEN: "OPEN",
  PAID: "PAID",
  UNCOLLECTIBLE: "UNCOLLECTIBLE",
  VOID: "VOID",
} as const;
export type InvoiceStatusEnum =
  (typeof InvoiceStatusEnum)[keyof typeof InvoiceStatusEnum];

export type Invoice = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  stripeInvoiceId: string;
  stripeSubscriptionId: string | null;
  number: string | null;
  status: InvoiceStatusEnum;
  currency: string;
  amountDue: number;
  amountPaid: number;
  amountRemaining: number;
  subtotal: number;
  total: number;
  tax: number | null;
  invoicePdfUrl: string | null;
  hostedInvoiceUrl: string | null;
  periodStart: Date | null;
  periodEnd: Date | null;
  paidAt: Date | null;
  dueDate: Date | null;
  userId: number;
};

export type InvoiceListQueryParams = {
  page: number;
};

export type InvoiceListResponse = {
  invoices: Invoice[];
  totalNumberOfPages: number;
};
